<template>
  <div id="payList">
      <ul>
          <li v-for="item in payLists" @click="details(item.orderId)">
            <div class="pay-top">
              <p>{{item.businessTime}}</p>
            </div>
            <div class="clear pay-bottom">
              <p class="float-l p1"></p>
              <p class="float-l p2">金额：</p>
              <p class="float-l p3">{{item.amount}}</p>
              <p class="float-l p4">元</p>
              <p class="float-r p5">{{item.state}}</p>
            </div>
          </li>
      </ul>
    <div :class="loadMoreHide ? 'load-more-hide' : 'load-more-normal'" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
      <span v-show="loadingShow">加载中...</span>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        busy: false,
        payLists: [],
        page:0,
        pageSize:10,
        sumPage:'',
        loadMoreHide:false,
        loadingShow:false,
      }
    },
    mounted () {
    },
    methods: {
      refresh (flag) {
        const _this = this
        _this.postRequest('payment/order/list', {
          'page': this.page,
          'size': this.pageSize
        },function (data) {
          if(flag){
            _this.loadingShow = false
            _this.payLists = _this.payLists.concat(data.list)
            if(data.isLastPage){
              _this.busy = true;
            }else{
              _this.busy = false;
            }
          }else{
            _this.payLists = data.list
            _this.busy = false;
          }
        })
      },
      loadMore () {
        // 多次加载数据
        this.busy = true
        this.loadingShow = true
        this.page ++
        this.refresh(true);
      },
      details(id){
        this.$router.push({
          name:'paymentDetail',
          params:{
            id:id,
          }
        })
      }
    }
  }
</script>
<style scoped>
  #payList{
    width: 100%;
    /*background-color: #f5f5f5;*/
  }
  #payList ul{
    padding-top: 26px;
    box-sizing: border-box;
  }
  #payList li{
    margin: 26px;
    background-color: #fff;
    border-radius:10px;
    box-shadow:6px 4px 10px rgba(227,227,227,.88);
  }
  .pay-top p{
    text-align: left;
    line-height: 90px;
    font-size:30px;
    color:rgba(51,51,51,1);
    padding-left: 27px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(242,242,242,1);
  }
  .pay-bottom p{
    line-height: 90px;
    font-size:30px;
    color:rgba(153,153,153,1);
  }
  .pay-bottom .p1{
    width:12px;
    height:12px;
    background:rgba(255,211,115,1);
    border-radius: 50%;
    margin: 40px 17px 0 27px;
  }
  .pay-bottom .p3{
    color:rgba(255,211,115,1);
    font-size:40px;
  }
  .pay-bottom .p4{
    font-size:23px;
    margin: 1px 0 0 4px;
  }
  .pay-bottom .p5{
    padding-right: 13px;
    box-sizing: border-box;
  }
  .clear{
    overflow: hidden;
    zoom: 1;
  }
  .float-l{
    float: left;
  }
  .float-r{
    float: right;
  }
.load-more-normal {
  text-align: center;
  line-height: 60px;
}

.load-more-hide {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pub-component/pay/payList.vue